import React, { useState } from 'react';
import './VenueHours.css';

interface VenueHoursProps {
  description: string;
}

const VenueHours: React.FC<VenueHoursProps> = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Extract hours from description
  const extractHours = (text: string): string[] | null => {
    if (!text) return null;
    
    // Look for "Hours:" section
    const hoursMatch = text.match(/Hours:\s*([\s\S]*?)(?:\n\n|Phone:|$)/);
    if (!hoursMatch) return null;
    
    // Split by newline and clean up
    const hourLines = hoursMatch[1]
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);
    
    return hourLines.length > 0 ? hourLines : null;
  };

  // Extract clean description without hours
  const getCleanDescription = (text: string): string => {
    if (!text) return '';
    
    // Remove hours section
    let clean = text.replace(/\n\nHours:[\s\S]*?(?=\n\n|$)/, '');
    
    // Remove phone section if at end
    clean = clean.replace(/\n\nPhone:.*$/, '');
    
    return clean.trim();
  };

  const hours = extractHours(description);
  const cleanDesc = getCleanDescription(description);

  if (!hours) {
    // No hours found, just show description
    return <p className="venue-description">{cleanDesc || description}</p>;
  }

  return (
    <div className="venue-info">
      {cleanDesc && <p className="venue-description">{cleanDesc}</p>}
      
      <div className="venue-hours-section">
        <button 
          className="hours-toggle"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-expanded={isExpanded}
        >
          <span className="hours-icon">🕐</span>
          <span className="hours-label">Hours</span>
          <span className={`toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
            ▼
          </span>
        </button>
        
        {isExpanded && (
          <div className="hours-content">
            {hours.map((line, index) => (
              <div key={index} className="hours-line">
                {line}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VenueHours;
